// extracted by mini-css-extract-plugin
var _1 = "EntityTabPostsToolbar-moduledropdown__fa2Se FloatingSelectDropdown-moduledropdown__O8nBT";
var _2 = "EntityTabPostsToolbar-moduleorderingButton__Oy1x6";
var _3 = "EntityTabPostsToolbar-moduleorderingOption__T3qem";
var _4 = "EntityTabPostsToolbar-moduleorderingSelect__MhZje";
var _5 = "EntityTabPostsToolbar-moduletoolbar__EBX8E TableControlBar-moduleTableControlBar__oSO8o";
export { _1 as "dropdown", _2 as "orderingButton", _3 as "orderingOption", _4 as "orderingSelect", _5 as "toolbar" }
